import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { IAppCoreState } from 'src/app/core/state';
import { RightPanelItem, WriteupDetailRightPanelAction } from 'src/app/feature/writeups-detail/state/actions/writeup-detail-right-panel.action';
import { DealRoute } from 'src/app/shared/model/api';

@Component({
  selector: 'con-app-toaster',
  templateUrl: './con-app-toaster.html',
  styleUrls:['con-app-toaster.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConAppToaster extends Toast implements OnInit, OnDestroy {
  data;
  constructor(private readonly _store: Store<IAppCoreState>,toastrService: ToastrService, public toastPackage: ToastPackage, private readonly router: Router) {
    super(toastrService, toastPackage);
   }
  public ngOnInit() {
    this.data = this.toastPackage.config.payload
  }
  navigateToDetail()
  {
    let navExtra = this.getNavigationExtras(this.data?.fullToastObject);
    if(this.data.type === 'DEAL_COMMENT'){
    this._store.dispatch(new WriteupDetailRightPanelAction(RightPanelItem.Notes));
    }
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(['wd/writeup-detail'], navExtra);
  }

  private getNavigationExtras(data) {
    const dealRoute: DealRoute = {
      customer: data?.customer ? data.customer.firstName + data.customer.lastName : undefined,
      dealType :(data?.deal?.paymentType)?( data?.deal?.paymentType === 'APR' ? 'finance' : data?.deal?.paymentType?.toLowerCase()):data?.deal?.dealType,
      dealStatus: data?.deal?.status,
      dealTransactionId: data?.deal?.dealTransactionId,
      salesConsultant: data?.type === 'DEAL_COMMENT' ? data?.deal?.dealTermComment?.commentGivenBy : data?.deal?.salesPerson,
      isNotification: false,
      timestamp: Date.now(),
    };
  
    const navigationExtras: NavigationExtras = {
      // queryParams: { "dealRoute": JSON.stringify(dealRoute) },
      skipLocationChange: false,
      state: dealRoute
    };
  
    return navigationExtras;
  }
}

